import type { AcceptableValue } from 'reka-ui'
import type { InjectionKey } from 'vue'

/** One choice a Select offers, as the native mirror needs it: the value, and whether it can be chosen. */
export type NativeOption = { value: AcceptableValue; disabled: boolean }

/**
 * How each `SelectItem` tells the `Select` it sits in that it exists, so a value set on the hidden native field
 * the Select mirrors its value on comes back as that item's own value, and a disabled item cannot be chosen
 * through it. Reka keeps its own register of items private, so the kit keeps one of its own. `register` takes a
 * reader rather than a snapshot, so an item whose props change is read afresh, and returns the call that takes
 * the item back out when it unmounts.
 */
export type NativeOptionRegistry = { register: (read: () => NativeOption) => () => void }

export const NATIVE_OPTIONS: InjectionKey<NativeOptionRegistry> = Symbol('zh-select-native-options')
